import { ModelApiService } from './BaseApiService'

export default class MessageApiService extends ModelApiService {
  constructor() {
    super('message')
  }
}
